import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DetailsConfig, SharedUiDetailsModule } from '@snelstart/ui-details';
import { ButtonConfiguration, SharedUiButtonModule } from '@snelstart/ui-button';
import { Observable, Subject, takeUntil } from 'rxjs';
import { BokkzAlgDataService, BokkzDivDataService, BokkzDivLogic, ClientEntity } from '@snelstart-ventures/fiscaal/domain-logic';
import { ToastService } from '@snelstart/ui-toast';
import { InhoudingsplichtigeComponent } from '../dividend/inhoudingsplichtige/inhoudingsplichtige.component';
import { AlgemeenComponent } from '../dividend/algemeen/algemeen.component';
import { ContactgegevensComponent } from '../dividend/contactgegevens/contactgegevens.component';
import { InhoudingsvrijstellingComponent } from '../dividend/inhoudingsvrijstelling/inhoudingsvrijstelling.component';
import { OpgaafComponent } from '../dividend/opgaaf/opgaaf.component';
import { NormaaltariefComponent } from '../dividend/normaaltarief/normaaltarief.component';
import { VerdragstariefComponent } from '../dividend/verdragstarief/verdragstarief.component';
import { BijzonderhedenComponent } from '../dividend/bijzonderheden/bijzonderheden.component';
import { VoorkomingComponent } from '../dividend/voorkoming/voorkoming.component';
import { OverzichtComponent } from '../dividend/overzicht/overzicht.component';
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import { TekstInhoudingsplichtigeComponent } from '../dividend/toelichtingen-tekst/tekst-inhoudingsplichtige/tekst-inhoudingsplichtige.component';
import { TekstContactgegevensComponent } from '../dividend/toelichtingen-tekst/tekst-contactgegevens/tekst-contactgegevens.component';
import { TekstVragenVoorafComponent } from '../dividend/toelichtingen-tekst/tekst-vragen-vooraf/tekst-vragen-vooraf.component';
import { TekstMetInhoudingDividendbelastingComponent } from '../dividend/toelichtingen-tekst/tekst-met-inhouding-dividendbelasting/tekst-met-inhouding-dividendbelasting.component';
import { TekstMetInhoudingsvrijstellingComponent } from '../dividend/toelichtingen-tekst/tekst-met-inhoudingsvrijstelling/tekst-met-inhoudingsvrijstelling.component';
import { TekstMetInhoudingDividendbelastingBuitenlandComponent } from '../dividend/toelichtingen-tekst/tekst-met-inhouding-dividendbelasting-buitenland/tekst-met-inhouding-dividendbelasting-buitenland.component';
import { TekstMetInhoudingsvrijstellingBuitenlandComponent } from '../dividend/toelichtingen-tekst/tekst-met-inhoudingsvrijstelling-buitenland/tekst-met-inhoudingsvrijstelling-buitenland.component';
import { TekstOverigeVragenComponent } from '../dividend/toelichtingen-tekst/tekst-overige-vragen/tekst-overige-vragen.component';
import { TekstDividendbelastingComponent } from '../dividend/toelichtingen-tekst/tekst-dividendbelasting/tekst-dividendbelasting.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'snelstart-venture-fiscaal-feature-tax-dividend-details',
    templateUrl: './feature-tax-dividend-details.component.html',
    styleUrl: './feature-tax-dividend-details.component.scss',
    imports: [
        CommonModule,
        SharedUiDetailsModule,
        SharedUiButtonModule,
        InhoudingsplichtigeComponent,
        AlgemeenComponent,
        ContactgegevensComponent,
        InhoudingsvrijstellingComponent,
        OpgaafComponent,
        NormaaltariefComponent,
        VerdragstariefComponent,
        BijzonderhedenComponent,
        VoorkomingComponent,
        OverzichtComponent,
        SharedUiDialogModule,
        TekstInhoudingsplichtigeComponent,
        TekstContactgegevensComponent,
        TekstVragenVoorafComponent,
        TekstMetInhoudingDividendbelastingComponent,
        TekstMetInhoudingsvrijstellingComponent,
        TekstMetInhoudingDividendbelastingBuitenlandComponent,
        TekstMetInhoudingsvrijstellingBuitenlandComponent,
        TekstOverigeVragenComponent,
        TekstDividendbelastingComponent,
    ],
})
export class FeatureTaxDividendDetailsComponent implements OnInit, OnDestroy {
    @Input() public id!: string;
    private destroy$ = new Subject<void>();
    public clientEntity = {} as ClientEntity;
    public dialogInfoVisible = false;

    constructor(
        public logicService: BokkzDivLogic,
        private algDataService: BokkzAlgDataService,
        private dataService: BokkzDivDataService,
        public toastService: ToastService,
    ) {}

    ngOnInit() {
        this.algDataService.client.pipe(takeUntil(this.destroy$)).subscribe((value) => {
            this.clientEntity = value;
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public detailsConfig = DetailsConfig.create({
        hideArrowButtons: true,
    });

    public config() {
        return ButtonConfiguration.create({
            onClick: () =>
                new Observable((subscription) => {
                    setTimeout(() => {
                        subscription.next(true);
                        subscription.complete();
                        this.saveForm();
                    }, 200);
                }),
        });
    }

    showButtonInfo(id: string): boolean {
        const toegestaneIds: string[] = [
            'Inhoudingsplichtige',
            'Contactgegevens',
            'Vragen vooraf',
            'Inhouding dividendbelasting',
            'Inhoudingsvrijstelling',
            'Inhouding dividendbelasting buitenland',
            'Inhoudingsvrijstelling buitenland',
            'Overige vragen',
            'Dividend en -belasting',
        ];
        return toegestaneIds.includes(id);
    }

    public showDialogInfo() {
        this.dialogInfoVisible = true;
    }

    public saveForm(): void {
        setTimeout(() => {
            this.logicService.postDividendTaxEntity(this.clientEntity.sstRelationId!, false);
        }, 50);
    }
}
